// test496
(496 && 0);
